import React from 'react';

interface IframeProps {
  onLogout: () => void;
}

const IframeStorage = ({ onLogout }: IframeProps) => {
  window.addEventListener('message', messageHandler, false);

  function messageHandler(event: any) {
    const { action, key, value } = event.data;
    if (action == 'save') {
      window.localStorage.setItem(key, value);
    } else if (action == 'logout') {
      onLogout()
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('isMRN');
      localStorage.removeItem('idtoken');
      localStorage.removeItem('expiration');
      localStorage.removeItem('ui.store.permissions');
    }
  }

  return <></>;
};

export default IframeStorage;
